// General
import "./tipping-element.scss";
// i18next
import { useTranslation } from "react-i18next";
// Components
import CustomAvatar from "../../custom-avatar/custom-avatar";

const TippingElement = (props) => {
  const {
    profilePhoto,
    profileDecorations,
    username,
    levellingBadge,
    tipValue,
    tipAction,

    // Style
    borderColor = "none",
    backgroundColor = "none",
  } = props;

  // i18next variables
  const { t } = useTranslation();

  return (
    <div
      id="chat-section-tipping-element-subcomponent"
      style={{
        background: backgroundColor,
        border: borderColor !== "none" ? `1px solid ${borderColor}` : "none",
      }}
    >
      <div className="profile-picture-container">
        <CustomAvatar
          className="profile-picture"
          src={profilePhoto}
          profileBorder={profileDecorations?.profile_border_url}
        />
      </div>

      <div className="chat-info-container">
        <div className="chat-info">
          <span className="username">{username || "-"}</span>

          {levellingBadge && (
            <img
              className="levelling-badge"
              src={levellingBadge}
              alt="levelling-badge"
            />
          )}

          <span className="joined-text">
            {t("1on1.tip_request_fixed_desc", {
              coins: tipValue,
              request: tipAction,
            })}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TippingElement;
